import StatusField from "components/StatusField";
import {
  Datagrid,
  Filter,
  TextField,
  SearchInput,
  FunctionField,
  ListProps,
  SelectInput,
  ReferenceInput,
  ReferenceField,
} from "react-admin";
import { SchoolIdSelected } from "utils/tools";
import React from "react";
import { notRenewedStudentStatusList } from "./const";
import CustomBooleanField from "../../components/CustomBooleanField";
import ParentLinkField from "./components/ParentLinkField";
import CustomPagination from "../../components/CustomPagination";
import ConfirmStudentRenewalButton from "./components/ConfirmStudentRenewalButton";
import UpdatedByField from "../../components/UpdatedByField";
import ListWrapper from "../../components/ListWrapper";
import ActionsMenu from "../../components/ActionsMenu";
import ExportButton from "./components/ExportButton";

const StudentFilter = (props: any) => (
  <Filter {...props}>
    <SearchInput source="search" alwaysOn />
    <ReferenceInput
      label="Academic Year"
      source="academicYearId"
      reference="academicYears"
      filter={{
        SchoolId: Number(SchoolIdSelected()),
      }}
      alwaysOn
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
    <SelectInput
      label="Status"
      source="Status"
      choices={notRenewedStudentStatusList}
      alwaysOn
    />
  </Filter>
);

const breadcrumb = [{ link: "/studentRenewals", title: "Student Renewals" }];

const DueRenewalStudentList = (props: ListProps) => {
  return (
    <>
      <ListWrapper
        breadcrumb={breadcrumb}
        headerTitle="Regular Student Renewals"
        denseMode
        exporter={false}
        filters={<StudentFilter />}
        filter={{
          SchoolId: Number(SchoolIdSelected()),
        }}
        perPage={50}
        sort={{ field: "CreatedAt", order: "DESC" }}
        bulkActionButtons={false}
        actions={<ExportButton />}
        {...props}
        hasCreate={false}
        pagination={<CustomPagination />}
      >
        <Datagrid>
          <TextField source="student.id" label="Student Id" />
          <FunctionField
            label="Name"
            render={(record: any) =>
              `${record.student?.firstName} ${record.student?.lastName}`
            }
          />
          <FunctionField
            label="Academic Year Info"
            render={(record: any) => `${record.currentAcademicYear?.name}`}
          />
          <ReferenceField
            label="Parent Info"
            source="student.id"
            reference="students"
            link={false}
          >
            <FunctionField
              render={(record: any) => <ParentLinkField record={record} />}
            />
          </ReferenceField>
          <CustomBooleanField
            source="isMaxLevel"
            textForTrueValue="Yes"
            textForFalseValue="No"
          />
          <StatusField source="status" />
          <FunctionField
            label="Updated By"
            render={(record: any) => (
              <>
                {record.updatedBy === null ? (
                  "-"
                ) : (
                  <UpdatedByField data={record.updatedBy} />
                )}
              </>
            )}
          />
          <FunctionField
            label="Action"
            render={(record: any) => (
              <ActionsMenu
                render={[
                  record.status === "pending" && (
                    <ConfirmStudentRenewalButton
                      id={record.id}
                      studentId={record.student.id}
                      academicYearId={record.currentAcademicYear.id}
                    />
                  ),
                ]}
              />
            )}
          />
        </Datagrid>
      </ListWrapper>
    </>
  );
};

export default DueRenewalStudentList;
